import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.BudgetsPage.XeroBudgets.BudgetParams', {
    statusLabel: 'Status:',
    deactivated: 'Deactivated',
    active: 'Active',
    dateOfUploadLabel: 'Date of upload:',
    lastSyncLabel: 'Last sync:',
    checkPeriodLabel: 'Check period:',
    includeZeroAmountLabel: 'Consider zero amounts:',
    zeroAmountConsider: 'Yes',
    zeroAmountNotConsider: 'No',
    checkPeriodMonthly: 'Month',
    checkPeriodQuarterly: '3 months',
    checkPeriodHalfYearly: '6 months',
    checkPeriodYearly: 'Year',
    checkPeriodYTD: 'Year to date',
    annuallyWithCustomFirstMonth: 'Yearly starting from {month}',
    yearToDateWithCustomFirstMonth: 'YTD starting from {month}',
    customMonthPeriod: 'From {from} to {to}',
    budgetPeriod: 'Budget period:',
});
